import {useModelsContext} from "./ModelsContext";
import Navbar from "../../components/main/Navbar";
import Loading from "../../components/atoms/Loading";
import Table2 from "../../components/main/Table/Table2";
import {HeaderModels} from "../../data/TablesHeader";
import ListsOperations from "../../tools/consts";
import Pagination from "../../components/main/Pagination";
import DeleteModal from "../../components/atoms/DeleteModal";
import {Toaster} from "react-hot-toast";
import React from "react";
import TableSearchHeader from "../../components/CustomTable/TableSearchHeader";
import JsonModal from "./JsonModal";

const ModelsScreen = () => {
    const {
        listState,
        modalState,
        onSearchBtnClick,
        changePage,
        deleteDeviceModel,
        closeModal,
        openModal,
    } = useModelsContext();


    return (
        <div className="pb-7.5px">
            <Navbar titles={["دستگاه‌ها", "فهرست مدل‌ها"]}/>
            <div
                className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px  "
                dir="rtl">
                <TableSearchHeader
                    title={"فهرست مدل‌ها"}
                    number={listState.countAll}
                    placeholder={"جست و جو: اسم نمایشی، محیط سنجش و..."}
                    onSearchBtnClick={onSearchBtnClick}
                    countUnit={"مدل"}
                    buttnText={"افزودن مدل جدید"}
                    hasBtn={true}
                    exportFile={false}
                    path={"/admin/device/models/add"}
                    onClick={() => {
                    }}
                />

                {listState.loading ? (
                    <Loading height={"h-66"}/>
                ) : (
                    <>
                        {<Table2
                            headers={HeaderModels}
                            tableData={listState.list}
                            emptyText={"مدلی یافت نشد."}
                            heightEmptyState={"h-66"}
                            limit={listState.pageLimit}
                            pageNumber={listState.pageNumber}
                            operations={
                                ListsOperations.getDeviceModelsList((item) => openModal("delete", item)
                                    , null, (item) => openModal("json", item))
                            }
                            hasOperation={true}
                        />}
                        <Pagination
                            changePage={changePage}
                            countAll={listState.countAll}
                            currentPage={listState.pageNumber}
                        />
                    </>
                )}
                <DeleteModal
                    text={`آیا برای حذف مدل “${modalState.selectedItem == null ? "" : modalState.selectedItem.seriname}” مطمئن هستید؟`}
                    showDeleteModal={modalState.mode === "delete" && modalState.isOpen}
                    closeDeleteModal={closeModal}
                    RemoveItem={deleteDeviceModel}
                    title="اخطار حذف اطلاعات"
                />

                <JsonModal showModal={modalState.mode === "json" && modalState.isOpen} closeModal={closeModal}
                           data={modalState.selectedItem}
                />

                <Toaster/>
            </div>
        </div>
    );
}
export default ModelsScreen;